import * as types from '../mutation-types';
import PhoneQueuesAPI from '../../api/phoneQueues';
import WallboardStatsAPI from '../../api/wallboardStats';

const state = {
  records: {},
  unhandledMissedCount: 0,
  wallboardStats: {
    outboundCallsByOutboundRuleNamePrefix: {},
    userAvailabilityByInboxPrefix: {},
  },
  uiFlags: {
    isFetching: false,
    isFetchingWallboardStats: false,
  },
};

const getters = {
  getPhoneQueues($state) {
    return Object.values($state.records);
  },
  getUnhandledMissedCount($state) {
    return $state.unhandledMissedCount;
  },
  getWallboardStats($state) {
    return $state.wallboardStats;
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
};

const actions = {
  get: async ({ commit }) => {
    commit(types.default.SET_PHONE_QUEUE_UI_FLAG, { isFetching: true });
    try {
      const { data } = await PhoneQueuesAPI.get();
      commit(types.default.CLEAR_PHONE_QUEUES);
      commit(types.default.SET_PHONE_QUEUES, data);
    } finally {
      commit(types.default.SET_PHONE_QUEUE_UI_FLAG, { isFetching: false });
    }
  },

  getWallboardStats: async ({ commit }) => {
    commit(types.default.SET_PHONE_QUEUE_UI_FLAG, {
      isFetchingWallboardStats: true,
    });
    try {
      const { data } = await WallboardStatsAPI.get();
      commit(types.default.SET_WALLBOARD_STATS, data);
    } finally {
      commit(types.default.SET_PHONE_QUEUE_UI_FLAG, {
        isFetchingWallboardStats: false,
      });
    }
  },

  updateFromWebsocket: ({ commit }, data) => {
    // Data can be a single queue or an array of queues
    if (Array.isArray(data)) {
      data.forEach(queue => {
        commit(types.default.UPDATE_PHONE_QUEUE, queue);
      });
    } else {
      commit(types.default.UPDATE_PHONE_QUEUE, data);
    }
  },

  updateMissedCallsCount: ({ commit }, count) => {
    commit(types.default.UPDATE_MISSED_CALLS_COUNT, count);
  },

  pickupCall: async (_, { callerId }) => {
    await PhoneQueuesAPI.pickupCall(callerId);
  },

  updateWallboardStatsFromWebsocket: ({ commit }, data) => {
    commit(types.default.SET_WALLBOARD_STATS, data);
  },
};

const mutations = {
  [types.default.SET_PHONE_QUEUE_UI_FLAG]($state, data) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...data,
    };
  },

  [types.default.CLEAR_PHONE_QUEUES]: $state => {
    $state.records = {};
  },

  [types.default.SET_PHONE_QUEUES]: ($state, data) => {
    const updatedRecords = {};
    const queues = data.phone_queues || data;
    const missedCount = data.unhandled_missed_count || 0;

    queues.forEach(queue => {
      updatedRecords[queue.id] = queue;
    });
    $state.records = updatedRecords;
    $state.unhandledMissedCount = missedCount;
  },

  [types.default.SET_WALLBOARD_STATS]: ($state, data) => {
    $state.wallboardStats = {
      outboundCallsByOutboundRuleNamePrefix:
        data.outbound_calls_by_outbound_rule_name_prefix || {},
      userAvailabilityByInboxPrefix:
        data.user_availability_by_inbox_prefix || {},
    };
  },

  [types.default.UPDATE_PHONE_QUEUE]: ($state, queue) => {
    $state.records = {
      ...$state.records,
      [queue.id]: queue,
    };
  },

  [types.default.UPDATE_MISSED_CALLS_COUNT]: ($state, count) => {
    $state.unhandledMissedCount = count;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
